<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card styleClass="very-compact-card p-3">
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="taskType.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Бюджетная статья</label>
            <crm-direction-single-select
              [directions]="directions"
              [(selectedDirection)]="taskType.direction"
              [groupsDisabled]="true"
              [styleClass]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-direction-single-select>
            <small
              *ngIf="errors?.direction"
              class="p-error">
              {{ errors.direction | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Дедлайн по-умолчанию</label>
            <p-inputNumber
              [(ngModel)]="taskType.defaultDeadline"
              [min]="0"
              [ngClass]="{ 'ng-invalid ng-dirty': errors?.defaultDeadline }"
              styleClass="w-full"
              prefix="Через "
              suffix=" дн."
              class="w-full"></p-inputNumber>
            <small
              *ngIf="errors?.defaultDeadline"
              class="p-error">
              {{ errors.defaultDeadline | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Приоритет по-умолчанию</label>
            <crm-single-select
              optionValue="name"
              [options]="priorities"
              [(selectedItem)]="taskType.defaultPriority"
              [styleClass]="errors?.defaultPriority ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.defaultPriority ? 'ng-invalid ng-dirty' : ''"
              [isTemplateCombined]="true"
              [filter]="false"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-priority="item">
                {{ priority?.value | helpdeskTaskPriorityName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.defaultPriority"
              class="p-error">
              {{ errors.defaultPriority | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Шаблон полей</label>
            <crm-eav-entity-type-single-select
              [(selectedType)]="taskType.entityType"
              [isError]="$any(errors?.entityType)"
              appendTo="body"></crm-eav-entity-type-single-select>
            <small
              *ngIf="errors?.entityType"
              class="p-error">
              {{ errors.entityType | join }}
            </small>
          </div>
        </div>
      </p-card>

      <p-card
        header="ИИ ассистент"
        styleClass="mt-3">
        <div class="field">
          <label class="font-medium">ИИ агент</label>
          <crm-ai-agent-single-select
            [(selectedEntity)]="taskType.agent"
            (selectedEntityChange)="changeAiAgent($event)"
            [isError]="$any(errors?.agent)"
            [isAutoReply]="true"
            [onlyActive]="true"
            [showClear]="true"
            [isNotAutoSelect]="true"
            appendTo="body"></crm-ai-agent-single-select>
          <small
            *ngIf="errors?.agent"
            class="p-error">
            {{ errors.agent | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Кол-во часов для автоматического ответа</label>
          <p-inputNumber
            [(ngModel)]="taskType.autoReplyHours"
            [min]="0"
            [ngClass]="{ 'ng-invalid ng-dirty': errors?.autoReplyHours }"
            styleClass="w-full"
            suffix=" ч."
            class="w-full"></p-inputNumber>
          <small
            *ngIf="errors?.autoReplyHours"
            class="p-error">
            {{ errors.autoReplyHours | join }}
          </small>
        </div>

        <div class="field-checkbox mb-0">
          <p-checkbox
            [(ngModel)]="taskType.askPermissionAnswer"
            [binary]="true"
            inputId="askPermissionAnswer"></p-checkbox>
          <label [for]="'askPermissionAnswer'">Разрешение на ответ</label>
        </div>
      </p-card>

      <p-card
        header="Участники"
        styleClass="mt-3">
        <div class="field">
          <label class="font-medium">Ответственный</label>
          <crm-user-single-select
            [(selectedUser)]="taskType.responsible"
            [isError]="$any(errors?.responsible)"
            [showClear]="true"
            appendTo="body"></crm-user-single-select>
          <small
            *ngIf="errors?.responsible"
            class="p-error">
            {{ errors.responsible | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Группы</label>
          <crm-user-group-multi-select
            [(selectedUserGroups)]="taskType.userGroupAuditors"
            [isFloatLabel]="false"
            appendTo="body"
            [class]="errors?.userGroupAuditors ? 'ng-invalid ng-dirty' : ''"
            [styleClass]="errors?.userGroupAuditors ? 'ng-invalid ng-dirty' : ''">
          </crm-user-group-multi-select>
          <p
            *ngIf="errors?.userGroupAuditors"
            class="p-error">
            {{ errors.userGroupAuditors | join }}
          </p>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveTaskType()"></crm-button>
      <div class="flex align-items-center gap-2">
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && !taskType.deleted"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteTaskType()"></crm-button>
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && taskType.deleted"
          icon="pi pi-undo"
          label="Восстановить"
          styleClass="p-button-info p-button-text"
          (onClick)="restoreTaskType()"></crm-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
